import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SpeakersPage from "./pages/SpeakersPage";
import ExperiencePage from "./pages/ExperiencePage";
import SchedulePage from "./pages/SchedulePage";
import AttendeeGuidePage from "./pages/AttendeeGuidePage";
import HotelTravelPage from "./pages/HotelTravelPage";
import ADAAssistancePage from "./pages/ADAAssistancePage";
import FAQsPage from "./pages/FAQsPage";
import BecomeSponsorPage from "./pages/BecomeSponsorPage";
import BecomeVendorPage from "./pages/BecomeVendorPage";
import BecomeVolunteerPage from "./pages/BecomeVolunteerPage";
import JoinGroupPage from "./pages/JoinGroupPage";
import GetBaptizedPage from "./pages/GetBaptizedPage";
import GetDisciplerPage from "./pages/GetDisciplerPage";
import TreasureHuntPage from "./pages/TreasureHuntPage";
import StayConnectedPage from "./pages/StayConnectedPage";
import MerchPage from "./pages/MerchPage";
import BadgeActivationPage from "./pages/BadgeActivationPage";
import ContactPage from "./pages/ContactPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/speakers" element={<SpeakersPage />} />
          <Route path="/experience" element={<ExperiencePage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/attendee-guide" element={<AttendeeGuidePage />} />
          <Route path="/hotel-travel" element={<HotelTravelPage />} />
          <Route path="/ada-assistance" element={<ADAAssistancePage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/become-sponsor" element={<BecomeSponsorPage />} />
          <Route path="/become-vendor" element={<BecomeVendorPage />} />
          <Route path="/become-volunteer" element={<BecomeVolunteerPage />} />
          <Route path="/join-group" element={<JoinGroupPage />} />
          <Route path="/get-baptized" element={<GetBaptizedPage />} />
          <Route path="/get-discipler" element={<GetDisciplerPage />} />
          <Route path="/treasure-hunt" element={<TreasureHuntPage />} />
          <Route path="/stay-connected" element={<StayConnectedPage />} />
          <Route path="/merch" element={<MerchPage />} />
          <Route path="/badge-activation" element={<BadgeActivationPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
